'use client';

import { SplitedTextProps } from '@/models/Headings';

import { BackToTopIcon } from './icons';
import IconLink from './links/IconLink';
import SectionTitle from './SectionTitle';

interface SubSectionTitleProps extends SplitedTextProps {
  url: string;
  linkText: string;
  linkAnimation?: boolean;
}
export default function SubSectionTitle(props: SubSectionTitleProps) {
  const { url, linkText, linkAnimation = true, ...rest } = props;

  return (
    <div className='flex flex-col items-start gap-8 md:flex-row md:items-end'>
      <h2>
        <SectionTitle {...rest} />
      </h2>
      <IconLink
        href={url}
        variant='unstyled'
        icon={BackToTopIcon}
        className='gap-3 text-white'
        classNames={{ icon: 'pointer-events-none' }}
        scrollToAnchor
        data-aos={linkAnimation ? 'fade-in' : null}
        data-aos-delay='700'
        data-aos-anchor={rest.anchor ? rest.anchor : null}
      >
        {linkText}
      </IconLink>
    </div>
  );
}
